<template>
    <aside>

        <div class="o-albumSidebar">
            <img class="img-fluid header__logo" src="assets/img/adoptuj-kravicku-logo.svg" alt="adoptuj-kravicku-logo">
            <h3>Môj album</h3>

            <ul class="m-albumSiebar__menu">
                <li>
                    <router-link :to="{ name: 'album-uspechy' }" class="a-albumSidebar__item --uspechy">
                        <span class="icon --trophy"></span>Moje úspechy
                    </router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'album-kravicky' }" class="a-albumSidebar__item --kravicky">
                        <span class="icon --cows"></span>Kolekcia
                    </router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'album-anatomia' }" class="a-albumSidebar__item --anatomia">
                        <span class="icon --cowBody"></span>Anatómia kravičky
                    </router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'album-recepty' }" class="a-albumSidebar__item --recepty">
                        <span class="icon --recipes"></span>Mliečne recepty
                    </router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'album-omalovanky' }" class="a-albumSidebar__item --omalovanky">
                        <span class="icon --omalovanky"></span>Omaľovánky
                    </router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'album-videosekcia' }" class="a-albumSidebar__item --videosekcia">
                        <span class="icon --videosekcia"></span>Kravička TV
                    </router-link>
                </li>
            </ul>

            <ul class="m-albumSidebar__profileList">
                <li v-if="profil.pouzivatel_id">
                    <a v-if="profil.pouzivatel_id.farma_pouzivatela.length != 0" 
                       :href="'https://www.adoptujkravicku.sk/hra/farma/moja-farma?' 
                       + profil.pouzivatel_id.id + '&' 
                       + profil.pouzivatel_id.pouzivatel_name + '&' 
                       + profil.pouzivatel_email" 
                       class="a-albumSidebar__item">
                        <span class="icon --user"></span>Moja farma
                    </a>
                </li>
                <li>
                    <router-link :to="{ name: 'kravicky' }" class="a-albumSidebar__item">
                        <span class="icon --cows"></span>Moje kravičky
                    </router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'profil' }" class="a-albumSidebar__item">
                        <span class="icon --profile"></span>Môj profil
                    </router-link>
                </li>
            </ul>

            <!--<div class="m-helperText">
                <span class="a-helperIcon"></span>
                <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy.</p>
            </div>-->
            <button id="closeAlbumMenu" class="btn --primary d-md-none"><span class="icon"></span></button>

        </div>
        <button id="openAlbumMenu" class="btn --primary d-md-none"><span class="icon"></span></button>

    </aside>
</template>



<script>
    export default {
        props: [
            'profil'
        ],
        mounted() {
        }
    }
</script>